import StoriesScene from '@/scenes/Stories';
import { initializeRootStore } from '@/stores';
import { getEnv, getSnapshot } from 'mobx-state-tree';

interface Props {
  pageContent: any;
}

const StoriesPage = ({ pageContent }: Props) => {
  return <StoriesScene content={pageContent} />;
};

export const getStaticProps = async () => {
  const rootStore = initializeRootStore();

  await rootStore.storiesStore.loadItems();

  const stories = await getEnv(rootStore).strapiService.getAllStories();

  stories.forEach((story) => {
    const _story = story;
    _story.bear.story = {
      id: story.id,
      name: story.bearName,
      slug: story.slug,
    };
    rootStore.storiesStore.setItems([_story]);
    rootStore.bearsStore.setItems([_story.bear]);
  });

  const pageContent = await getEnv(rootStore).strapiService.get(
    '/stories-page',
    {
      params: {
        'populate[banner][populate]': '*',
        'populate[cta][populate]': '*',
      },
    },
  );

  return {
    props: {
      initialState: getSnapshot(rootStore),
      pageContent: pageContent.data.data.attributes,
    },
  };
};

export default StoriesPage;
